<template>
  <b-card>
    <div class="p-2">
      <b-row>
        <b-col cols="2">
          <img
            src="@/assets/images/bajavoluntaria/icons/policia.png"
            class="my-4"
          >
        </b-col>
        <b-col>
          <b-row>
            <b-col
              cols="12"
              class="mx-2"
            >
              <p class="mr-2 text-26 font-weight-bold c-blue">
                {{ datos.nombre }}
              </p>
              <!-- <p class="mr-2 text-16 font-weight-bold">
                REQUISITOS:
              </p> -->
            </b-col>
            <b-col
              cols="12"
              class="mr-3-2 mt-4 "
            >
              <!-- eslint-disable vue/no-v-html -->
              <h5
                class="text-16 mb-0 ml-4"
                v-html="getRequisitosPreview(datos.requisitos)"
              />
              <h5 class="ml-2 mb-3 font-weight-bold ml-4">
                . . .
              </h5>
              <convocatoria-detalles
                :visible="view"
                :convocatoria="datos"
                :documentos="documentos"
                @hidden="value => {
                  view = value
                }"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col />
            <b-col
              md="4"
              class="mb-2"
            >
              <!-- v-b-toggle="`collapse-${datos.id}`" -->
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="success"
                class="btn-card"
                block
                @click="checkView"
              >
                <!-- {{ textRequerimets(view) }} -->
                Ver más
              </b-button>
            </b-col>
            <b-col md="4">
              <b-button
                variant="primary"
                class="btn-card"
                block
                :disabled="!datos.register"
                @click="
                  $router.push({
                    name: 'registro',
                    params: {
                      id: datos.id,
                      name: datos.nombre,
                      datosEmpleado: datos.datos_empleado,
                      convocatoria: datos,
                    },
                  })
                "
              >
                Regístrate
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>

import {
  BButton,
  BCard,
  BCol,
  // BCollapse,
  BRow,
  VBToggle,
  // BModal,
  // VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import CatalogosService from '@/services/CatalogosService'
import ConvocatoriaDetalles from './ConvocarotiaFull.vue'

export default {
  directives: {
    'b-toggle': VBToggle,
    // 'b-modal': VBModal,
    Ripple,
  },
  components: {
    BButton,
    BCard,
    BCol,
    // BCollapse,
    BRow,
    ConvocatoriaDetalles,
    // BModal,
  },
  props: {
    datos: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      view: false,
      documentos: [],
    }
  },
  computed: {
    textRequerimets() {
      return view => (view ? 'Ver menos' : 'Ver más')
    },
    getRequisitosPreview() {
      return requisitos => requisitos.split('===')[0]
      // return requisitos => requisitos.split('===')[0]
    },
    getRequisitosComplemento() {
      return requisitos => requisitos.split('===')[1]
    },
  },
  mounted() {
    this.fetchConvocatoriaDocumentos(this.datos.id)
  },
  methods: {
    showConvocatoria() {
      const url = this.datos.documento !== null ? this.datos.documento : ''
      window.open(url, '_target')
    },
    checkView() {
      this.view = !this.view
    },
    fetchConvocatoriaDocumentos(id) {
      CatalogosService.getCatPubConvocatoriaDocumento({
        convocatoria: id,
      }).then(response => {
        this.documentos = response.data
      })
    },
  },
}
</script>

<style>
.c-blue {
  /* color: rgb(red, green, blue); */
  color: #054EB1;
}
</style>
